// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured_featured__1jgQ2","wrapper":"Featured_wrapper__1EY6u","link":"Featured_link__2NJlC","content":"Featured_content__24fIV"};